import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClientErrorHandler implements ErrorHandler {
  handleError(err: Error) {
    console.error(err);
  }
}
